<template>
  <div>
    <el-form :model="dataForm" label-position="top" :rules="rules" ref="ruleForm" class="demo-dataForm mt-10">
      <el-row type="flex" justify="space-between">
        <el-col :span="8" class="left">
          <el-form-item label="您的店铺名称" prop="storeName" label-width="150px">
            <el-input v-model="dataForm.storeName" maxlength="32"></el-input>
          </el-form-item>
          <el-form-item label="营业时间 (请谨慎更改，更改营业时间会清除时间标签)" label-width="150px">
            <div slot="label">营业时间 <span style="color: #dd6161">(请谨慎更改，更改营业时间会清除时间标签)</span></div>
            <div class="flex-n">
              <el-form-item label="" prop="timeBegin" label-width="0">
                <el-select :disabled="!fixedState" class="flex-1 mr-10" v-model="dataForm.timeBegin" placeholder="请选择"
                           @change="changeOpenTime">
                  <el-option
                    v-for="(itm,idx) in openTimeList"
                    :key="idx"
                    :label="itm.label"
                    :value="itm.value">
                  </el-option>
                </el-select>

              </el-form-item>
              <el-form-item label="" prop="timeEnd" label-width="0">
                <el-select :disabled="(dataForm.timeBegin?false:true)||!fixedState" class="flex-1"
                           v-model="dataForm.timeEnd"
                           placeholder="请选择" @change="changeCloseTime">
                  <el-option
                    v-for="(itm2,idx2) in closeTimeList"
                    :key="idx2"
                    :label="itm2.label"
                    :value="itm2.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-button style="height: fit-content" class="ml-10" type="primary" @click="fixedTime">
                {{fixedState?'确定':'修改'}}
              </el-button>
              <el-button style="height: fit-content" class="ml-10" v-show="fixedState" @click="cancelTime">取消
              </el-button>

            </div>
          </el-form-item>
          <el-form-item label="咨询默认提醒日期" prop="askAlertDaysAfter" label-width="150px">
            <el-input v-model="dataForm.askAlertDaysAfter">
              <template slot="append">天后</template>
            </el-input>
          </el-form-item>
          <el-form-item label="预定默认提醒日期" prop="orderAlertDaysBefore" label-width="150px">
            <el-input v-model="dataForm.orderAlertDaysBefore">
              <template slot="append">天前</template>
            </el-input>
          </el-form-item>
          <el-form-item label="订金默认金额" prop="orderDefaultMoney" label-width="150px">
            <el-input v-model="dataForm.orderDefaultMoney">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="14" class="right">
          <el-card class="box-card" shadow="never">
            <div slot="header" class="clearfix">
              <span>预定时间标签</span>
              <el-button style="float: right; padding: 3px 0" type="text"
                         v-if="dataForm.timeList&&dataForm.timeList.length>0"
                         :disabled="dataForm.timeList&&dataForm.timeList.length==4" @click="addTimeList">添加
              </el-button>
            </div>
            <div v-if="dataForm.timeList&&dataForm.timeList.length==0" style="text-align: center">
              暂无时间标签
              <el-button type="text" @click="addTimeList">添加</el-button>
            </div>
            <div v-else>
              <div v-for="(item,index) in dataForm.timeList">

                <div class="flex-n">
                  <!--                                  :label="'标签'+labelList[index]"-->
                  <el-form-item
                    class="item flex-1 mr-10"
                    :prop="'timeList.' + index + '.tagName'"
                    :rules="{required: true, message: '请设置标签名称', trigger: ['change','blur']}">
                    <el-input clearable placeholder="标签名" v-model="item.tagName"></el-input>
                  </el-form-item>
                  <el-form-item
                    class="item"
                    :prop="'timeList.' + index + '.beginTime'"
                    :rules="{required: true, message: '请设置标签起始时间', trigger:  ['change','blur']}">
                    <!--                    <el-time-select-->
                    <!--                        placeholder="起始时间"-->
                    <!--                        v-model="item.beginTime"-->
                    <!--                        class="mr-10 w-130"-->
                    <!--                        :picker-options="{start: '07:00',step: '00:30', end: '23:30',maxTime: item.endTime}">-->
                    <!--                    </el-time-select>-->
                    <el-select class="w-130 mr-10" v-model="item.beginTime" clearable placeholder="请选择"
                               @change="changeStartTime($event,index)">
                      <el-option
                        v-for="(itm,idx) in timeStartList"
                        :key="idx"

                        :label="itm.label"
                        :value="itm.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item class="item " :prop="'timeList.' + index + '.endTime'"
                                :rules="{required: true, message: '请设置标签结束时间', trigger:  ['change','blur']}">
                    <el-select :disabled="item.beginTime?false:true" class="w-130" v-model="item.endTime" clearable
                               placeholder="请选择">
                      <el-option
                        v-for="(itm2,idx2) in timeEndList"
                        :key="idx2"
                        :disabled="Number(itm2.value.replace(':',''))<=Number(item.beginTime.replace(':',''))"

                        :label="itm2.label"
                        :value="itm2.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <div>
                    <i class="el-icon-delete fs-20 closedel" v-pointer @click="dataForm.timeList.splice(index,1)"></i>
                  </div>

                </div>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <el-form-item class="mt-10">
        <el-button type="primary" :disabled="fixedState" @click="submitForm('ruleForm')">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  export default {
    name: "base-setting",
    data() {
      return {
        labelList: ['一', '二', '三', '四'],
        dataForm: {
          timeList: [],
          timeBegin: '00:00',//营业开始时间
          timeEnd: '24:00',//营业结束时间
          zxtime: '',
          ydtime: '',
          money: ''
        },
        oldTimeBegin: '',
        oldTimeEnd: '',
        fixedState: false,//修改
        timeList: [],
        id: '',
        rules: {
          timeBegin: [
            {required: true, message: '营业开始时间不能为空', trigger: ['blur', 'change']}
          ],//营业开始时间
          timeEnd: [
            {required: true, message: '营业结束时间不能为空', trigger: ['blur', 'change']}
          ],//营业结束时间
          zxtime: [
            {required: true, message: '咨询提醒日期不能为空', trigger: 'blur'}
          ],
          ydtime: [
            {required: true, message: '预定提醒日期不能为空', trigger: 'blur'}
          ],
          money: [
            {required: true, message: '定金默认金额不能为空', trigger: 'blur'}
          ],

        },
        timeStartList: [],
        timeEndList: [],

        openTimeList: [],
        closeTimeList: []
      }
    },
    mounted() {
      this.getData();
      this.openTimeList = this.getTimeList('0', '2400')
    },
    methods: {
      getData() {
        this.$axios.get('/config/baseByStoreId/' + this.$root.getStorage('storeId')).then(res => {
          console.log('基本信息', res)
          this.id = res.data.id;
          this.dataForm = res.data;
          let timeList = [];
          let timeRange = res.data.timeRange.split('-')
          this.$set(this.dataForm, 'timeBegin', timeRange[0] || '00:00');
          this.changeOpenTime(this.dataForm.timeBegin);
          this.$set(this.dataForm, 'timeEnd', timeRange[1] || '24:00');
          this.timeStartList = this.getTimeList(this.dataForm.timeBegin, this.dataForm.timeEnd);

          for (let i = 0; i < res.data.orderTag.length; i++) {
            timeList.push({
              tagName: res.data.orderTag[i].tagName,
              beginTime: res.data.orderTag[i].beginTime,
              endTime: res.data.orderTag[i].endTime,
            })
          }
          this.timeEndList = this.getTimeEndList(this.dataForm.timeBegin, this.dataForm.timeEnd);
          this.$set(this.dataForm, 'timeList', timeList);


        }).catch(err => {
          this.$message.error(err.msg);
        })
      },
      getTimeEndList(beginTime, endTime) {
        let timeList = [];
        let startNum = beginTime.indexOf(':30') > -1 ? (Number(beginTime.replace(':', '')) + 70) : (Number(beginTime.replace(':', '')) + 30)
        for (let i = startNum; i <= Number(endTime.replace(':', '')); i = i % 100 == 30 ? (i + 70) : (i + 30)) {
          timeList.push({
            label: this.getFormatTimeText(String(i)),
            value: this.getFormatTime(String(i))
          });
        }
        return timeList;
      },
      getTimeList(beginTime, endTime) {
        let timeList = [];
        for (let i = Number(beginTime.replace(':', '')); i < Number(endTime.replace(':', '')); i = i % 100 == 30 ? (i + 70) : (i + 30)) {
          timeList.push({
            label: this.getFormatTimeText(String(i)),
            value: this.getFormatTime(String(i))
          });
        }
        return timeList;
      },
      //修改相关时间
      fixedTime() {
        this.fixedState = !this.fixedState;
        if (this.fixedState) {
          this.oldTimeBegin = this.dataForm.timeBegin;
          this.oldTimeEnd = this.dataForm.timeEnd;
        } else {
          if (this.oldTimeBegin != this.dataForm.timeBegin || this.oldTimeEnd != this.dataForm.timeEnd)
            this.$set(this.dataForm, 'timeList', []);
        }
      },
      cancelTime() {
        this.fixedState = false;
        this.$set(this.dataForm, 'timeBegin', this.oldTimeBegin);
        this.$set(this.dataForm, 'timeEnd', this.oldTimeEnd);
      },
      //更改营业开始时间
      changeOpenTime(e) {
        this.$set(this.dataForm, 'timeEnd', '');
        console.log(e)
        let closeTimeList = [];
        if (e) {
          let startNum = e.indexOf(':30') > -1 ? (Number(e.replace(':', '')) + 70) : (Number(e.replace(':', '')) + 30)
          for (let i = startNum; i < startNum + 2400; i = i % 100 == 30 ? (i + 70) : (i + 30)) {
            closeTimeList.push({
              label: this.getFormatTimeText(String(i)),
              value: this.getFormatTime(String(i))
            });
          }
        }
        this.closeTimeList = closeTimeList;
      },
      changeCloseTime(e) {
        this.timeStartList = this.getTimeList(this.dataForm.timeBegin, this.dataForm.timeEnd);
        this.timeEndList = this.getTimeEndList(this.dataForm.timeBegin, this.dataForm.timeEnd);
      },
      getFormatTimeText(time) {
        let ytime = Number(time.replace(':', ''));
        var c1 = Number(ytime / 100).toFixed(0)
        c1 = c1 < 10 ? ('0' + c1) : (c1 > 23 ? ('次日' + ((c1 - 24) > 9 ? (c1 - 24) : ('0' + (c1 - 24)))) : c1);
        c1 = c1 + ':' + (ytime % 100 ? '30' : '00')
        return c1;
      },
      getFormatTime(time) {
        let ytime = Number(time.replace(':', ''));
        var c1 = Number(ytime / 100).toFixed(0)
        c1 = (c1 < 10 ? ('0' + c1) : c1) + ':' + (ytime % 100 ? '30' : '00')
        return c1;
      },

      changeStartTime(e, idx) {
        // this.dataForm.timeList[idx].endTime = '';
        // let timeEndList = [];
        // if (e) {
        //   console.log(1321)
        //   let startNum = e.indexOf(':30') > -1 ? (Number(e.replace(':', '')) + 70) : (Number(e.replace(':', '')) + 30)
        //   for (let i = startNum; i <= Number(this.dataForm.timeEnd.replace(':', '')); i = i % 100 == 30 ? (i + 70) : (i + 30)) {
        //     timeEndList.push({
        //       label: this.getFormatTimeText(String(i)),
        //       value: this.getFormatTime(String(i))
        //     });
        //   }
        // }
        // this.dataForm.timeList[idx].timeEndList = timeEndList;
      },
      addTimeList() {
        console.log(1)
        let idx = this.dataForm.timeList.length || 0;
        console.log(idx, this.labelList, this.labelList[1])
        this.dataForm.timeList.push({tagName: '时间标签' + (idx + 1), beginTime: '', endTime: '', timeEndList: []})
      },
      submitForm(formName) {
        let dataForm = this.dataForm;
        for (let i in dataForm.timeList) {
          let beginTime = dataForm.timeList[i].beginTime,
            endTime = dataForm.timeList[i].endTime;
          if (Number(dataForm.timeBegin.replace(':', '')) > Number(beginTime.replace(':', '')) || Number(dataForm.timeEnd.replace(':', '')) < Number(endTime.replace(':', ''))) {
            return this.$message.error('店铺的营业时间是' + dataForm.timeBegin + '-' + dataForm.timeEnd + ',' + dataForm.timeList[i].tagName + '的时间段设置有误')
          }
        }
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$axios.post('/config/baseUpdate', {
              "storeId": this.$root.getStorage('storeId'),
              "id": this.id,
              "storeName": dataForm.storeName,
              "askAlertDaysAfter": dataForm.askAlertDaysAfter,
              "orderAlertDaysBefore": dataForm.orderAlertDaysBefore,
              "orderDefaultMoney": dataForm.orderDefaultMoney,
              "orderTag": dataForm.timeList,
              "timeRange": dataForm.timeBegin + '-' + dataForm.timeEnd
            }).then(res => {
              this.$message.success('修改店铺信息成功');
            }).catch(err => {
              this.$message.error(err.msg);
            })
          } else {
            this.$message.error('表单填写有误');
            return false;
          }
        });
      },
    }
  }
</script>

<style scoped lang="scss">
  .base {
    .demo-dataForm {
      padding: 0 60px;

      .right {
        min-width: 520px;
      }
    }

    .closedel {
      line-height: 40px;
      color: #606266;
      margin-left: 10px;

      &:hover {
        color: #5295e7;
      }
    }
  }
</style>
